import React from 'react';
import {useAsync} from "react-async";
import {httpClient} from '../service';
import {ActionResult, HttpMethod} from '../model';
import LoadingHtml from '../shared/Loading';
import ErrorPage from '../shared/ErrorPage';
import {RouteComponentProps} from 'react-router-dom';
import {TermsEntity} from '../model/TermsEntity';
import parse from 'html-react-parser';

const Terms = (props: RouteComponentProps<{ id: string }>) => { // 추가
    const match = props.match;
    const id = match.params.id ?? 'service';
    const url = `infos/terms/${id}`;
    const options = {promiseFn: httpClient, method: HttpMethod.GET, url};
    const {data: act, error, isLoading} = useAsync<ActionResult>(options);

    if (isLoading) return <LoadingHtml/>;
    if (error) return <ErrorPage/>;
    if (!act) return null;
    if (!act.result) return <ErrorPage/>;
    const model: TermsEntity = act?.data;
    if(model===null){
        return <ErrorPage/>;
    }
    const content = model.content === undefined ? '' : model.content;
    return (
        <>
            <div className="bloc l-bloc" id="bloc-0">
                <div className="container bloc-sm">
                    <div className="row">
                        <div className="col">
                            <div id="accordion-16855">
                                <h6 className="mg-md subtitle">{model.name}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bloc l-bloc" id="bloc-23">
                <div className="container ">
                    <div className="row">
                        <div className="col">
                            <p className="default-text">{parse(content)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

};

export default Terms;
